var React = require('react');

function BigArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.7298 52.4912L1.52148 37.4912L16.7298 22.4912","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1.52148 37.4912H71.4798","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BigArrowLeft.defaultProps = {"width":"73","height":"72","viewBox":"0 0 73 72","fill":"none"};

module.exports = BigArrowLeft;

BigArrowLeft.default = BigArrowLeft;
